import * as Styled from './styled';
import { TProcessingType } from './styled';

const ProcessingIcon = ({ type = 'notice' }: { type: TProcessingType }) => {
  return (
    // <div>
    <Styled.ProcessingIcon2 type={type}></Styled.ProcessingIcon2>
    // </div>
  );
};

export default ProcessingIcon;
